<template>
    <div class="images-block images-block--horizontal">
        <div class="images-block__scene-trigger" ref="sceneTrigger"></div>
        <div class="images-block__scene-pin" ref="scenePin">
            <div
                class="images-block__scroll-container"
                ref="scrollContainer"
                :style="scrollContainerStyle"
            >
                <ImageBlock
                    v-for="image in images"
                    :key="image.image"
                    v-bind="image"
                    @on-image-loaded="handleImageLoaded"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, onMounted, onBeforeUnmount, computed, reactive } from 'vue';
    import ScrollMagic from 'scrollmagic';
    import ImageBlock from '@/components/blocks/image-block/ImageBlock.vue';

    const props = defineProps({
        images: Array
    });
    const sceneTrigger = ref(null);
    const scenePin = ref(null);
    const scrollContainer = ref(null);
    const state = reactive({ scrollOffset: 0, progress: 0, scrollContainerWidth: 0 });
    let controller = new ScrollMagic.Controller();
    let pinScene = null;
    let scrollScene = null;

    const scrollContainerStyle = computed(() => {
        return `transform: translate(${-(
            state.scrollContainerWidth * state.progress
        )}px, 0) translate3d(0, 0, 0); padding-left:${-state.scrollOffset}px;`;
    });

    const init = () => {
        handleSizeChange();

        pinScene = new ScrollMagic.Scene({
            triggerElement: scenePin.value,
            triggerHook: 'onLeave',
            duration: getPinSceneDuration()
        })
            .setPin(scenePin.value) //
            .addTo(controller);

        scrollScene = new ScrollMagic.Scene({
            triggerElement: scenePin.value,
            triggerHook: 'onLeave',
            offset: state.scrollOffset,
            duration: state.scrollContainerWidth
        }).addTo(controller);

        scrollScene.on('progress', (e) => {
            state.progress = e.progress;
        });
        scrollScene.on('start', (e) => {
            handleSizeChange();
        });

        window.addEventListener('resize', handleSizeChange);
    };

    const handleSizeChange = () => {
        state.scrollOffset = -(window.innerWidth / 2);
        state.scrollContainerWidth = calculateScrollContainerWidth();

        if (pinScene) {
            pinScene.duration(getPinSceneDuration());
        }
        if (scrollScene) {
            scrollScene.offset(state.scrollOffset);
            scrollScene.duration(state.scrollContainerWidth);
        }
    };

    const handleImageLoaded = (e) => {
        handleSizeChange();
    };

    const calculateScrollContainerWidth = () => {
        return Array.from(scrollContainer.value.children).reduce((sum, x) => {
            return sum + x.getBoundingClientRect().width;
        }, 0);
    };

    const getPinSceneDuration = () => {
        return state.scrollContainerWidth + state.scrollOffset * 2;
    };

    onMounted(() => {
        init();
    });

    onBeforeUnmount(() => {
        window.removeEventListener('resize', handleSizeChange);
        pinScene.removePin(true);
        controller.removeScene(pinScene);
        controller.removeScene(scrollScene);
    });
</script>
